<div class="auth-card">
    <div class="dx-card content">
        <img src="assets/hopewell.svg" height="40" alt="hopewell logo" class="w-100"/>

        <div class="header">
            <div class="title">{{ title }}</div>
            <div class="description">{{ description }}</div>
        </div>
        <ng-content></ng-content>
    </div>
</div>
